import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'

import ProductCarousel, { ProductCardType } from './ProductCarousel'
import useRecentlyViewedProducts from '../../services/useRecentlyViewedProducts'

interface RecentlyViewedProductsCarouselProps {
  productCardType: ProductCardType
}

const RecentlyViewedProductsCarousel: FC<RecentlyViewedProductsCarouselProps> = (props) => {
  const { productCardType } = props

  const { t } = useTranslation('products')

  const { data: products, isLoading, carouselType } = useRecentlyViewedProducts()

  return (
    <ProductCarousel
      carouselType={carouselType}
      title={t('products:Recently viewed')}
      productCardType={productCardType}
      products={products}
      isLoading={isLoading}
      hide={!isLoading && !products?.length}
      testId="recently-viewed-products"
    />
  )
}

export default RecentlyViewedProductsCarousel
